
import "./billingSheet.css";
import React, { useState } from "react";
import ReactModal from "react-modal";
import { useGlobalContext } from "../../context";
import { useNavigate } from "react-router-dom";
import { pinCodeValidation } from "../../api";

function PinForEdit({ clientId }: { clientId: number | undefined }) {

    const {
        openPinForEdit,
        setOpenPinForEdit
    } = useGlobalContext()

    const navigate = useNavigate();
    const [pinCode, setPinCode] = useState<string>("");
    const [errorPin, setErrorPin] = useState<boolean>(false);

    const submitPinCode = async (): Promise<void> => {
        if (pinCode) {
            const responseData = await pinCodeValidation(pinCode);
            if (responseData.data === true) {
                setOpenPinForEdit(false);
                setPinCode("");
                navigate("/billing-edit-client", { state: { id: clientId } });
            }
            else {
                setErrorPin(true);
            }
        }
        else {
            setErrorPin(true);
        }
    }

    document.body.onkeydown = (e) => {
        if (e.key === "Enter" && pinCode) {
            submitPinCode().then(r => r);
        }
    }

    return (
        <ReactModal
            isOpen = { openPinForEdit }
            onRequestClose = {() => setOpenPinForEdit(false)}
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    zIndex: 300,
                },
                content: {
                    width: "80%",
                    maxWidth: '550px',
                    maxHeight: "240px",
                    height: "55vh",
                    border: 'none',
                    margin: "auto",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: "center",
                    justifyContent: "space-evenly",
                }
            }}
        >
            <div className = 'modal-deleteClient-content'>
                Enter Your Pin Code
            </div>
            <input
                type = { "text" }
                autoFocus = { true }
                className = "user-pin-code-input"
                value = { pinCode }
                onChange = { (e) => setPinCode(e.target.value) }
            />
            {
                errorPin ? <p className = "error-pin-code-text"> Invalid Pin Code </p> : null
            }
            <button
                className = "user-pin-code-button"
                onClick = { submitPinCode }
            >
                Submit
            </button>
        </ReactModal>
    )
}

export default PinForEdit
